<template>
  <div
    v-if="team.subscriptionExpired() || team.trialExpiring() || team.subscriptionExpiring()"
    class="full-width"
  >
    <div
      v-if="team.trialExpiring() && showHint"
      class="row bg-blue-grey text-blue-grey-2 q-py-sm q-px-lg"
    >
      <div class="row items-center full-width">
        <div class="col-auto">
          <q-icon name="info" color="blue-grey-2" style="font-size: 1.5rem;"/>
        </div>

        <div class="col q-px-md">
          <i18n tag="span" path="trial_expiring">
            <span place="trialExpirationDate">{{ team.trialExpirationDate() }}</span>
            <a place="settings" class="text-blue-grey-1 text-bold" href="#" @click.prevent="openSettings">{{ $tc('setting', 2) }}</a>
          </i18n>
        </div>

        <div class="col-auto">
          <q-icon name="close" style="font-size: 1.5rem;" class="cursor-pointer" @click.native="hideHint"/>
        </div>
      </div>
    </div>

    <div
      v-if="team.subscriptionExpiring() && showHint"
      class="row justify-start bg-warning text-white q-py-sm q-px-lg"
    >
      <div class="row items-center full-width">
        <div class="col-auto">
          <q-icon name="info" color="white" style="font-size: 1.5rem;"/>
        </div>

        <div class="col q-px-md">
          <i18n tag="span" path="subscription_expiring">
            <span place="subscriptionExpirationDate">{{ team.subscriptionExpirationDate() }}</span>
            <a place="settings" class="text-white text-bold" href="#" @click.prevent="openSettings">{{ $tc('setting', 2) }}</a>
          </i18n>
        </div>

        <div class="col-auto">
          <q-icon name="close" style="font-size: 1.5rem;" class="cursor-pointer" @click.native="hideHint"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      team: {
        type: Object,
        required: true
      }
    },

    data () {
      return {
        showHint: true
      }
    },

    computed: mapGetters(['activeTeam']),

    methods: {
      hideHint () {
        this.showHint = false
        document.body.style.removeProperty('--top-offset')
      },

      openSettings () {
        this.$router.push({ name: 'team-settings', params: { teamId: this.activeTeam.id }, query: { tab: 'subscription' } })
      }
    },

    mounted () {
      if ((this.team.trialExpiring() || this.team.subscriptionExpiring()) && this.showHint) {
        document.body.style.setProperty('--top-offset', '41px')
      }
    }
  }
</script>
